<template>
    <div>
        <v-dialog v-model="open" persistent max-width="600">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title>Seleccionar fechas</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="$emit('close')">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pt-6">
                    <v-card outlined>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="4" class="ma-auto">
                                    Selecciona un tipo
                                </v-col>
                                <v-col cols="12" md="8">
                                    <v-select
                                        v-model="type"
                                        outlined
                                        dense
                                        hide-details
                                        flat
                                        :items="[{
                                            text: 'Dia',
                                            value: 'day'
                                        },{
                                            text: 'Mes',
                                            value: 'month'
                                        }]"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card outlined class="mt-3">
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="4" class="ma-auto">
                                    Selecciona el {{ type === 'day' ? 'Dia': 'Mes'}}:
                                </v-col>
                                <v-col cols="12" md="8">
                                    <v-menu
                                        ref="start"
                                        v-model="start.open"
                                        :close-on-content-click="false"
                                        :return-value.sync="start.date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="start.date"
                                                dense
                                                solo
                                                flat
                                                outlined
                                                hide-details
                                                prepend-inner-icon="mdi-calendar"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker 
                                            locale="es-es" 
                                            v-model="start.date" 
                                            no-title 
                                            scrollable 
                                            :type="type === 'day' ? 'date': 'month'"
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="start.open = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.start.save(start.date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        outlined
                        small
                        @click="$emit('close')"
                        >Cancelar</v-btn
                    >
                    <v-btn 
                        color="accent" 
                        small
                        @click="save"
                        >Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="error.active" :timeout="3000">
            {{ error.message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="error"
                    text
                    v-bind="attrs"
                    @click="error.active = false"
                >
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    name: 'datePicker',
    props: ['open'],
    data() {
        return {
            type: 'hour',
            error:{
                message: '',
                active: false,
            },
            start:{
                open: false,
                date: null
            }
        }
    },
    methods: {
        save(){
            if(this.start.date === null) return this.showError('Seleccione una fecha')
            const start = this.formatDate(this.start.date)
            start.setHours(0,0,0,0)
            
            this.$emit('newValues', { start, type: this.type })
            this.$emit('close')
        },
        formatDate(str_date){
            if(this.type === 'month') str_date = `${str_date}-1`
            const [ year, month, day ] = str_date.split('-')
            
            const date = new Date()
            date.setDate(day)
            date.setMonth(month - 1)
            date.setFullYear(year)
            
            return date
        },
        showError(message){
            this.error.message = message
            this.error.active = true
        }
    },
}
</script>